import { render, staticRenderFns } from "./Reflection.vue?vue&type=template&id=bbc70e7e&scoped=true"
import script from "./Reflection.vue?vue&type=script&lang=js"
export * from "./Reflection.vue?vue&type=script&lang=js"
import style0 from "./Reflection.vue?vue&type=style&index=0&id=bbc70e7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc70e7e",
  null
  
)

export default component.exports